import { DeleteItemsModal } from 'ui/indexPages/modals/DeleteItemsModal';
import { useModalContext } from 'utils/contexts/modal';
import { useTranslation } from 'modules/domains/list';
import {
  useOnConfirmDelete,
  useItemsToDeleteContent,
  useDeleteListModalDisplayText,
} from './hooks';

export const DeleteListsModal = () => {
  const { t } = useTranslation();
  const { hideModal } = useModalContext();
  const onConfirm = useOnConfirmDelete();
  const content = useItemsToDeleteContent();
  const displayTextForContentItems = useDeleteListModalDisplayText();

  return (
    <DeleteItemsModal
      onClose={hideModal}
      onConfirm={onConfirm}
      content={content}
      displayTextForContentItems={displayTextForContentItems}
      warning={t('indexPage.modals.deleteList.warning')}
    />
  );
};
